import React, { memo, useMemo } from 'react';
import { Tooltip } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { PRODUCT_INFO, NOT_AVAILABLE } from '../../../constants/patientChart.constant';

export const NextOrder = memo(({
  productInfoCache = new Map([
    ['', PRODUCT_INFO()],
  ]),
  orderId = '',
  orderDate = '',
  orderTime = '',
  loading = false,
}) => {
  const { productNamesAsText = '', api: productsAPI, } = useMemo(() => {
    const _collection = new Map(productInfoCache);
    if (!_collection.has(orderId)) {
      _collection.set(orderId, PRODUCT_INFO());
    }
    const _productInfo = _collection.get(orderId);
    const products = _productInfo.Product;

    const productNames = [];
    let productNamesAsText = '';
    products.forEach(({ ProductName: displayTitle }, index) => {
      if (productNames.length) {
        productNames.push({ key: index, label: ', ', className: 'bold m-r-2' });
        productNamesAsText += ', ';
      }
      productNames.push({ key: index, label: displayTitle, className: 'bold' });
      productNamesAsText += displayTitle;
    });

    if (!_productInfo.api.loading && !productNames.length) {
      productNames.push({ key: 0, label: NOT_AVAILABLE, className: 'bold' });
      productNamesAsText += NOT_AVAILABLE;
    }

    return { products, api: _productInfo.api, productNames, productNamesAsText };
  }, [productInfoCache]);

  const OrderDateAndTime = new Map([
    [true, (
      <>
        <Skeleton variant='text' className='width-50 m-r-1' />
        <Skeleton variant='text' className='width-100' />
      </>
    )],
    [false, (
      <>
        <span className='bold m-r-1'>{orderTime}</span>
        {
          orderDate && <span className='bold'>- {orderDate}</span>
        }
      </>
    )]
  ]);
  const ProductName = new Map([
    [true, <Skeleton variant='text' className='flex flex-fill' />],
    [false, (
      <Tooltip title={productNamesAsText} placement='top' arrow>
        <span aria-label='product-names' className='bold height-20 overflow-ellipsis'>{productNamesAsText}</span>
      </Tooltip>
    )]
  ]);

  return (
    <div className='patient-chart-next-order flex flex-column width-420 min-width-420 p-l-2 p-r-2 height-94'>
      <div className='flex'>
        <label className='m-r-2'>Next Visit:</label>
        {OrderDateAndTime.get(loading)}
      </div>

      <div className='flex align-items-center line-20 height-20'>
        <label className='m-r-2 min-width-105'>Product Name:</label>
        {ProductName.get(loading || productsAPI.loading)}
      </div>
    </div>
  );
});

export default NextOrder;
